<template>
  <div class="container-fluid">
    <div class="heightcontainer">
      <landing-navbar></landing-navbar>
        <section class="section1 mt-2 pb-2 backgroundcolor13">
            <div class="container row pb-5 pt-5 no-gutters mx-auto ">
                <div class="col-12 pt-lg-5 mt-5 mt-md-1">
                    <div class="col-lg-12 p-0 mt-5 pt-lg-5 pb-lg-5 mt-lg-1 section1content">
                        <div class="top-padding d-lg-flex">  
                            <div class="col-lg-6 p-0 d-flex flex-column my-auto">
                                <span class="proximanova fontsize24 white">Worknotion presents the <span class="proximanova-bold">all-new</span> "Campus Ambassador Programme."</span>
                                <span class="proximanova-bold fontsize36 white mt-3">Calling all the young minds out there to spread "Creative Revolution" in this world</span>
                                <div class="pb-5 mb-5 mb-lg-1">
                                <button class="btn fontsize18 icon-scroll signupbtnstyles p-2 mt-3 pl-5 pr-5 borderradius20 mt-4 backgroundcolor3 proximanova-semibold white" @click="openForm">Apply Now</button>
                                </div>
                            </div>
                            <div class="col-md-7 mx-auto col-lg-6 my-auto">  
                                <img src="../../assets/studentAmbassador1.png" alt="img" class="img-fluid mt-5 mt-lg-3 negmargin"> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section2 d-flex mx-auto justify-content-between">
            <div class="container row pt-5 mb-5 no-gutters mx-auto ">
                <div class="mx-auto p-4 text-center">
                    <span class="fontsize40 proximanova-bold black">Have a look at what's in the bag for you in this <span class="blue">Program</span></span>
                </div>
                <div class="d-flex flex-column col-lg-9 mx-auto mb-5">
                    <span class="proximanova fontsize20 black80 mb-3">{{aboutprogram.title}}</span>
                    <span class="d-flex flex-column" v-for="(wcap, index1) in aboutprogram.points" :key="'about'+index1">
                        <span class="proximanova fontsize20 black80 mb-3">{{wcap}}</span>
                    </span>
                </div>
            </div>
        </section>
        <section class="section1 mt-2 pb-2 backgroundcolor13">
            <div class="container row pb-5 pt-5 no-gutters mx-auto ">
                <div class="col-12 pb-5 pt-5 d-lg-flex">
                    <div class="col-lg-6 d-flex flex-column">  
                        <span class="fontsize36 proximanova-bold white">I thought, what's in it <span class="blue">for You?</span></span> 
                        <div class="col-md-7 mx-auto my-auto d-block d-lg-none">  
                            <img src="../../assets/studentAmbassador2.png" alt="img" class="img-fluid mt-4"> 
                        </div>
                        <div class="mt-3"></div>
                        <span class="d-flex flex-column" v-for="(item, index) in foryou" :key="'foryou'+index">
                            <span class="proximanova fontsize20 white mb-2">{{item}}</span>
                        </span>
                        <span class="proximanova-bold fontsize20 white mt-4">Also, Learning opportunities</span>
                        <span class="proximanova fontsize20 white">Specialized Masterclasses (365 days)</span>
                    </div>
                    <div class="col-md-7 mx-auto col-lg-6 my-auto d-none d-lg-block">  
                        <img src="../../assets/studentAmbassador2.png" alt="img" class="img-fluid mt-4"> 
                    </div>
                </div>
            </div>
        </section>
        <section class="section2 d-flex mx-auto justify-content-between">
            <div class="container row pb-5 pt-5 mb-5 no-gutters mx-auto ">
                <div class="mx-auto p-5 text-center">
                    <span class="fontsize40 proximanova-bold black">I was wondering who could <span class="blue">apply?</span></span>
                </div>
                <div class="d-flex flex-column col-12 mb-5" v-for="(wca, index11) in whocanapply1" :key="'wca'+index11">
                    <span class="proximanova-bold fontsize32 black mb-3">{{wca.title}}</span>
                    <span class="d-flex flex-column" v-for="(wcap, index1) in wca.points" :key="index1">
                        <span class="proximanova fontsize20 black60 mb-1">{{wcap}}</span>
                    </span>
                </div>
                <div class="mx-auto p-5 text-center">
                    <span class="fontsize40 proximanova-bold black">Time waits for none. Unleash your hidden powers by joining a team</span>
                </div>
                <div class="d-lg-flex justify-content-between col-12 pl-0 pr-0">
                    <div class=" card card1 borderradius20 border-0 shadow mt-3 mb-5 p-4" v-for="(wca2, index12) in whocanapply2" :key="'wca2'+index12">
                        <div class="d-flex flex-column text-center p-2">
                            <span class="proximanova-bold fontsize24 blue">{{wca2.title}}</span>
                            <span class="proximanova fontsize14 black mt-3 mb-2 text-left">{{wca2.description}}</span>
                            <span class="d-flex flex-column" v-for="(wca2p, index13) in wca2.points" :key="index13">
                                <span class="proximanova fontsize14 black mt-2 text-left">{{wca2p}}</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="mx-auto p-5 text-center">
                    <span class="fontsize40 proximanova-bold black"> "Basic functioning" of this Program</span>
                </div>
                <span class="d-flex flex-column col-12" v-for="(item1, index2) in howitwork" :key="index2">
                    <div class="col-md-10 col-lg-7 mx-auto card borderradius20 border-0 shadow mt-3 mb-5 p-5">
                        <div class="d-flex flex-column text-center">
                            <span class="proximanova-bold fontsize32 blue">{{item1.title}}</span>
                            <span class="proximanova fontsize24 black mt-3">{{item1.description}}</span>
                        </div>
                    </div>
                </span>
                <div class="mx-auto d-flex flex-column p-5 text-center">
                    <span class="fontsize40 proximanova-bold black">Hope in now for the change</span>
                    <span class="pb-5">
                    <button class="btn fontsize18 icon-scroll signupbtnstyles signupbtnstyles1 p-2 mt-2 pl-5 pr-5 borderradius20 mx-auto mt-4 backgroundcolor3 proximanova-semibold white" @click="openForm">Apply Now</button>
                    </span>
                </div>
            </div>
        </section> 
        <section class="section1 mt-2 pb-2 backgroundcolor13">
            <div class="container row pb-5 pt-5 no-gutters mx-auto ">
                <div class="col-12 p-5">
                    <div class="text-center">  
                        <span class="fontsize40 proximanova-bold white">For Queries</span> 
                        <h2 class="fontsize24 proximanova-semibold white mt-3">Email : support@worknotion.com</h2>    
                    </div>
                </div>
            </div>
        </section>
    </div>    
    <Footer class="footer" ></Footer>
  </div> 
</template>
<script>
import Footer from '../LandingFooter.vue'
import LandingNavbar from './Navbar.vue'
import wndata from '../../js/wn_data.json'
export default {
  components: { 
    Footer,
    LandingNavbar
  },
  data() {
    return {
        aboutprogram : {
            title : "The Campus Ambassador's day-to-day responsibilities include:",
            points : [
                "1.  Transforming into the official Superhero alias Ambassador while simultaneously working as your college’s brand representative of Worknotion.",
                "2.  Spreading awareness and knowledge about worknotion among the student community.",
                "3.  Use your social media channels to promote worknotion and increase follower base and connections.",
                "4.  Generate importance on Worknotion through activities for college societies and fest departments."
            ]
        },
        foryou : [
            '1.  A certificate of appreciation.',
            '2.  Exciting rewards (Winners of ambassador tag)',
            '3.  Letter of recommendation (Outstanding performers)',
            '4.  Exclusive coupons from Worknotion merchants',
            '5.  Internship Opportunities and Live Projects.',
            '6.  Rewarding gifts for top performers such as iPhones,iPad, laptops and much more.', 
        ],
        whocanapply1 : [
            {
                title : "Candidates who:",
                points : [
                    '1. Can apply between (16th August-30th September 2022)',
                    '2. Should be available for 3 months',
                    '3. Possess relevant skills and interests',
                    '4. Can communicate effectively',
                    '5. Have leadership qualities'
                ]
            },
            {
                title : "Hold on, and there's more about you",
                points : [
                    '1. Aspire to become a talented professional equipped with in-demand skills.',
                    '2. Actively participating in different college communities and clubs.',
                    '3. Currently studying in College.',
                    '4. Good at communicating through social media and also in-person interaction.',
                    '5. Want to be a Content Creator recognised by brands worldwide?'
                ]
            }
        ],
        whocanapply2 : [
            {
                title : "BLOGGERS TEAM",
                description : "If you like to express your creativity through blogging, bring your love for technology and its importance to the Worknotion blog. In your blogs, write words that generate a positive force inspiring your peers and tech-aspirants. Grow your blogging with us.",
                points : [
                    "•  Take part in Content Creation that resonates with the student community.",
                    "•  Gain an understanding and research on social media to learn and implement new trends.",
                    "•  Develop your creative skills by designing campaigns for brands."
                ]
            },
            {
                title : "SOCIAL MEDIA TEAM",
                description : "Do you identify yourself as a social butterfly, then utilise this ability as a skill to make money and building wealth through social media communication. Take over our social media channels through posts and updates that show your creativity and represent evolving ideas.",
                points : [
                    "•  Curate and conduct marketing campaigns at your neighbourhood campuses across your community circle.",
                    "•  Innovate and come up with ideas to create unique experiences for the Worknotion Student Community.",
                    "•  Identify and foster long-term student associations"
                ]
            },
            {
                title : "TECHNICAL TEAM",
                description : "If planning, managing & handling activities/events interests you, then lead the show with your fresh ideas as the newest tech events & engage its participants by springing out the skilful talent with competitive spirits.",
                points : [
                    "•  Invent new methods that upgrade consumer technology to a higher level.",
                    "•  Be the new face of the student tech community",
                    '•  Take initiatives in carrying on research across student groups focusing on "tech talent."'
                ]
            }
        ],
        howitwork : [
            {
                title : 'Choose Team',
                description : 'Content or social media, or Technical Events'
            },
            {
                title : 'Apply',
                description : 'One Student or a Team of up to 6 members'
            },
            {
                title : 'Screening Test',
                description : 'A test to evaluate individual skills required for team builders'
            },
            {
                title : 'Become a Worknotion Campus Ambassador',
                description : 'Grab benefits and value that come with this Program'
            }
        ]
    };
  },
  methods: {
    openForm : function() {
      var x = document.createElement('a')
      x.target = '_blank'
      x.href = wndata.studentambassadorprogrammeGoogleform;
      x.click()
    }
  },
  mounted: function() {
    window.scrollTo(0, 0)
  },
  computed: {
    
  }
};
</script>
<style scoped>
.card{
    width: 100%;
    border-radius: 5px;
}
section {
 margin: 0 0 0rem 0rem  !important ;
}
.signupbtnstyles{
  width: 300px;
  height: 70px;
  font-size: 26px;
  border-radius: 40px !important;
}
.signupbtnstyles1{
    margin-left: -150px !important;
}
.footer {
  background-color: black;       
  color : white;
  position: sticky;
}
.top-padding{
  padding-top:3rem !important;
}
h2{
  font-weight: 300;
}
.section1 {
  background-color:white;
}
.section2 {
  background-color:white;
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .section1content{
    margin-top: 12% !important;
  }
  .top-padding{
    padding-top:0rem !important;
  }
  .fontsize36{
    font-size: 30px;
  }
  .fontsize40{
    font-size: 32px;
  }
  .signupbtnstyles{
    border-radius: 40px !important;
    margin-top: 40px !important;
  }
}
@media screen and (min-width: 600px) and (max-width: 800px) {
  .section1content{
    margin-top: 12% !important;
  }
  .top-padding{
    padding-top:0rem !important;
  }
  .signupbtnstyles{
    border-radius: 40px !important;
    margin-top: 40px !important;
  }
}
@media screen and (min-width: 800px){  
  .card1{
    width: 32% !important;
  }
  .negmargin{
    margin-bottom: -25% !important;
  }
}
</style>
